import { invalidateAnalyticsCache } from './analyticsCacheSlice';
import { invalidateAnalyzedAppsCache } from './analyzedAppsCacheSlice';
import { invalidateFirmwareCache } from './firmwareCacheSlice';

export const clearAllCache = () => dispatch => {
  dispatch(invalidateAnalyticsCache());
  dispatch(invalidateAnalyzedAppsCache());
  dispatch(invalidateFirmwareCache());
};
